import logo from "./logo.svg";
import "./App.css";
import Support1 from "./Components/Support1";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// function App() {
//   return (
//     <div className="App">
//       <Support1 />
//     </div>
//   );
// }

function App() {
  return (
    <div className="App">
      {/* <BrowserRouter> */}
      <Routes>
        <Route exact path="/:company/:meetingId" element={<Support1 />}></Route>
        {/* <Route path="/videosdk" element={<Demo1 />}>
            
          </Route> */}
      </Routes>
      {/* </BrowserRouter> */}
    </div>
  );
}

export default App;
